import type { Site } from '../Site';

export const GetPriceNZ: Site = {
  id: 'getpricenz',
  logo: 'svg/getprice.svg',
  label: 'GetPrice NZ',
  analyticsName: 'getpricenz',
  hostname: 'getprice.com.nz',
  platform: 'responsive',
  selector: 'main a',
};
